// Password rules for parent accounts. Supabase enforces its own minimum server-side; these give a clear message before
// the request is sent. (Turn on "Leaked password protection" in the Supabase dashboard as well: it rejects passwords
// found in known breaches, which no client-side list can match.)

export const PASSWORD_MIN = 10;
export const PASSWORD_HINT = `At least ${PASSWORD_MIN} characters, with a letter and a number.`;

// a short list of the passwords people pick most; the dashboard's breach check covers the rest
const COMMON = ['password', 'qwerty', 'letmein', 'welcome', 'iloveyou', 'abc123', 'lumio', 'monkey', 'football',
  'dragon', 'sunshine', 'princess', 'admin', 'login', 'master', 'baseball', 'shadow', 'superman', 'trustno'];

/** A message saying what is wrong with this password, or null when it is acceptable. */
export function passwordProblem(password, email = '') {
  const pw = String(password || '');
  if (pw.length < PASSWORD_MIN) return `Use at least ${PASSWORD_MIN} characters.`;
  if (pw.length > 72) return 'Use 72 characters or fewer.';
  if (!/[A-Za-z]/.test(pw) || !/[0-9]/.test(pw)) return 'Use at least one letter and one number.';
  if (/^(.)\1+$/.test(pw)) return 'Choose a password that is not one character repeated.';
  const lower = pw.toLowerCase();
  if (COMMON.some((w) => lower.includes(w))) return 'That password is too easy to guess. Try a short phrase with a number.';
  const local = String(email || '').split('@')[0].toLowerCase();
  if (local.length >= 4 && lower.includes(local)) return "Don't include your email name in your password.";
  return null;
}
